module.exports = __webpack_public_path__ + "img/Salesman.8ad22aca.svg";